import React from "react";
import Section from "./Section";
import { hackathons } from "../data/HackathonDetails";

// Renders nothing until entries exist in HackathonDetails.js — no
// placeholder/empty state, since an unfilled section reads worse than no
// section at all on a recruiter-facing page.
const HackathonWins = () => {
  if (hackathons.length === 0) return null;

  return (
    <Section
      id="hackathons"
      title="Hackathon Wins"
      subtitle="Hackathons and builder events I've participated in."
    >
      <ol className="space-y-4">
        {hackathons.map((entry) => (
          <li
            key={`${entry.event}-${entry.date}`}
            className="grid gap-1 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
          >
            <p className="font-mono text-xs text-faint sm:pt-1">
              {entry.date}
            </p>
            <div>
              <h3 className="text-lg font-semibold">{entry.event}</h3>
              <p className="mt-0.5 text-sm text-faint">{entry.role}</p>
              {/* <p className="mt-3 font-mono text-xs leading-relaxed text-faint">
                {entry.techStack}
              </p> */}
              {entry.link && (
                <a
                  href={entry.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block rounded-full border border-line px-4 py-1.5 text-sm font-medium transition-colors duration-100 hover:border-fg"
                >
                  View ↗
                </a>
              )}
            </div>
          </li>
        ))}
      </ol>
    </Section>
  );
};

export default HackathonWins;
